import { alias, date, deserialize, identifier, serializable } from "serializr";
import { IJsonObject } from "../api";

interface IProps {
	id?: number | null;
	firstName?: string;
	lastName?: string;
	email?: string;
	birthday?: Date | null;
	gender?: string;
	country?: string;
	phone?: string;
	uccIdNumber?: string;
	street?: string;
	city?: string;
}

export class Lead {
	public static fromJson(json: IJsonObject): Lead {
		return deserialize(Lead, json);
	}

	public static fromJsonArray(json: IJsonObject[]): Lead[] {
		return json.map((lead: IJsonObject) => this.fromJson(lead));
	}

	@serializable(identifier())
	public id: number | null;

	@serializable(alias("firstname"))
	public firstName: string;

	@serializable(alias("lastname"))
	public lastName: string;

	@serializable
	public email: string;

	@serializable
	public country: string;

	@serializable(date())
	public birthday: Date | null;

	@serializable
	public gender: string;

	@serializable
	public phone: string;

	@serializable
	public street: string;

	@serializable
	public city: string;

	@serializable(alias("ucc_id_number"))
	public uccIdNumber: string;

	get fullName() {
		return this.firstName + " " + this.lastName;
	}

	constructor({
		id = null,
		firstName = "",
		lastName = "",
		email = "",
		birthday = null,
		gender = "",
		country = "",
		phone = "",
		uccIdNumber = "",
		street = "",
		city = "",
	}: IProps = {}) {
		this.id = id;
		this.firstName = firstName;
		this.lastName = lastName;
		this.email = email;
		this.birthday = birthday;
		this.gender = gender;
		this.country = country;
		this.phone = phone;
		this.uccIdNumber = uccIdNumber;
		this.street = street;
		this.city = city;
	}
}
